/**
 * yd-reveal: data-reveal 进场动画（IntersectionObserver）。无外部库。
 * 源自 web-hand-off reveal.js：删 partials:loaded，补 shopify:section:load。
 * 尊重 prefers-reduced-motion。幂等（:not(.is-on)）。
 */
(function () {
  function init() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-on)');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-on'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var stagger = parseInt(e.target.dataset.revealStagger || '0', 10);
        setTimeout(function () { e.target.classList.add('is-on'); }, stagger);
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
